export const SUBMISSION_UPLOAD_LEAVE_EVENT = 'submission-upload:request-leave';

type SubmissionUploadLeaveDetail = {
  action?: () => void;
};

export const requestSubmissionUploadLeave = (action?: () => void) => {
  const leaveEvent = new CustomEvent<SubmissionUploadLeaveDetail>(
    SUBMISSION_UPLOAD_LEAVE_EVENT,
    {
      cancelable: true,
      detail: { action }
    }
  );

  const wasHandledByListener = !window.dispatchEvent(leaveEvent);

  if (!wasHandledByListener) {
    action?.();
  }

  return wasHandledByListener;
};

export type { SubmissionUploadLeaveDetail };
